import React from "react";
import {
  Document,
  Font,
  Image,
  Link,
  Page,
  PDFDownloadLink,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { batch } from "react-redux";
import BackButton from "../../components/common/Backbutton";
import CommonButton from "../../components/common/Button";
import logoBase63 from "../../assets/images/sidebar/PdfLogo_bg.png";

Font.register({
  family: "calibri",
  fonts: [
    { src: "/fonts/Calibri-Regular.ttf", fontWeight: "normal" },
    { src: "/fonts/Calibri-Bold.ttf", fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  page: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
    padding: "10px 15px 10px 15px",
    paddingBottom: 0,
    alignItems: "center",
  },
  vertical: {
    height: "1px",
    width: "100%",
    backgroundColor: "black",
  },
  headerText: {
    fontFamily: "calibri",
    fontSize: 12,
    fontWeight: "bold",
  },
  section: {
    marginBottom: 15,
    border: 1,
    borderColor: "black",
    borderStyle: "solid",
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "black",
    borderStyle: "solid",
  },
  row: {
    flexDirection: "row",
  },
  cell: {
    flex: 1,
    padding: 5,
    fontSize: 10,
    fontFamily: "calibri",
  },
  boldCell: {
    fontFamily: "calibri",
    fontWeight: "bold",
    color: "#003E52",
    fontSize: 12,
  },
  tablefooterText: {
    padding: 5,
    fontSize: 10,
    fontFamily: "calibri",
    flex: 1,
  },
  separator: {
    width: "100%",
    height: 2,
    backgroundColor: "black",
  },
  footer: {
    marginTop: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "15px  0px 0px 0px",
  },
});

const data = [
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1021", "1022"],
    quantity: ["10.00", "11.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1023"],
    quantity: ["10.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1024", "1025", "1024", "1025"],
    quantity: ["10.00", "11.00", "10.00", "11.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1026"],
    quantity: ["10.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1021", "1022"],
    quantity: ["10.00", "11.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1021", "1022"],
    quantity: ["10.00", "11.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1021", "1022"],
    quantity: ["10.00", "11.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1021", "1022"],
    quantity: ["10.00", "11.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1021", "1022"],
    quantity: ["10.00", "11.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1021", "1022"],
    quantity: ["10.00", "11.00"],
  },
  {
    productName: "PIANO BLACK",
    size: "800X2400",
    totalProductQty: "10.00",
    surface: "Glossy",
    batchNo: ["1021", "1022"],
    quantity: ["10.00", "11.00"],
  },
];

const Stockreport_pdf = () => {
  return (
    <Document>
      {data
        .reduce((acc, item, index) => {
          // Split data into chunks of 5 items per page
          if (index % 8 === 0) acc.push([]);
          acc[acc.length - 1].push(item);
          return acc;
        }, [])
        .map((chunk, pageIndex) => (
          <Page size="A4" style={styles.page} key={pageIndex}>
            <View fixed>
              <View style={styles.header}>
                <View style={{ display: "flex", flexDirection: "column" }}>

                <Image src={logoBase63} style={{ width: 150 }} />
                <Text style={{ fontSize: 12, fontFamily: "calibri" ,width: 250}}>
                303, Eden Ceramic City, Lalpar, NH 8-A, Morbi. 363642, Gujarat, India.
                </Text>
                </View>

                <View style={{ display: "flex", flexDirection: "column", }}>
                  <Text style={styles.headerText}>Stock Report</Text>
                  <Text style={styles.headerText}>Date: 23-12-2024</Text>
                </View>
              </View>
              <View style={styles.vertical}></View>
            </View>
            <View style={{ margin: "10px 15px 10px 15px" }}>
              <View style={[styles.section]}>
                {chunk.map((item, index) => (
                  <React.Fragment key={index}>
                    <View style={styles.row}>
                      <Text style={[styles.cell, styles.boldCell]}>Size:</Text>
                      <Text style={styles.cell}>{item.size}</Text>
                      <Text style={[styles.cell, styles.boldCell]}>
                        Surface:
                      </Text>
                      <Text style={styles.cell}>{item.surface}</Text>
                    </View>
                    <View
                      style={[styles.row, { borderBottom: "1px solid black" }]}
                    >
                      <Text style={[styles.cell, styles.boldCell]}>
                        Product Name:
                      </Text>
                      <Text style={styles.cell}>{item.productName}</Text>
                      <Text style={[styles.cell, styles.boldCell]}></Text>
                      <Text style={styles.cell}></Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "column",
                        justifyContent: "flex-end",
                      }}
                    >
                      {/* <View
                      style={{
                        flexDirection: "row",
                        borderTop: "1px solid black",
                        borderBottom: "1px solid black",
                        paddingBottom: 5,
                      }}
                    >
                      <Text style={[styles.cell, styles.boldCell]}></Text>
                      <Text style={[styles.cell, styles.boldCell]}></Text>
                      <View style={styles.tablefooterText}>
                        {(Array.isArray(item.batchNo) ? item.batchNo : []).map(
                          (batch, i) => (
                            <Text key={i} style={[styles.cell]}>
                              {batch}
                            </Text>
                          )
                        )}
                      </View>
                      <View style={[styles.tablefooterText]}>
                        {(Array.isArray(item.quantity) ? item.quantity : []).map(
                          (qty, i) => (
                            <Text key={i} style={styles.cell}>
                              {qty}
                            </Text>
                          )
                        )}
                      </View>
                    </View> */}

                      <View
                        style={[
                          {
                            flexDirection: "row",
                            borderBottom: "1px solid black",
                          },
                        ]}
                      >
                        <Text style={[styles.cell, styles.boldCell]}></Text>
                        <Text style={[styles.cell, styles.boldCell]}></Text>
                        <Text style={[styles.tablefooterText, styles.boldCell]}>
                          Total Product Qty:
                        </Text>
                        <Text style={styles.tablefooterText}>
                          {item.totalProductQty}
                        </Text>
                      </View>
                    </View>
                  </React.Fragment>
                ))}
              </View>
            </View>
             {/* footer */}
                    <View style={styles.footer} fixed>
                      <View style={styles.separator} />
                      <Text style={{ fontWeight: 600, fontSize: 11, padding: "10px 0px 5px 0px" }}>
                      303, Eden Ceramic City, Lalpar, NH 8-A, Morbi. 363642, Gujarat, India.

                      </Text>
                      <Text style={{ fontWeight: 600, fontSize: 11 }}>
                        <Link
                          style={{ color: "black", textDecoration: "none" }}
                          href="mailto:info@asiapacificceramic.com"
                        >
                          info@porcious.com
                        </Link>{" "}
                        | &nbsp;
                        <Link
                          style={{ color: "black", textDecoration: "none" }}
                          href="https://porcious.com/"
                        >
                          www.porcious.com
                        </Link>
                      </Text>
                    </View>
          </Page>
        ))}
    </Document>
  );
};

const Stock_Report = () => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
          flexWrap: "wrap",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <h2>Download Stock Report PDF</h2>
        </div>
        <PDFDownloadLink
          document={<Stockreport_pdf />}
          fileName={`stockreport.pdf`}
        >
          {({ blob, url, loading, error }) => {
            if (loading) return "Loading document...";
            if (error) {
              console.error("Error generating PDF:", error);
              return "Error generating PDF";
            }
            return <CommonButton buttonName="Download" color="white" />;
          }}
        </PDFDownloadLink>
      </div>
      <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <Stockreport_pdf />
      </PDFViewer>
    </div>
  );
};

export default Stock_Report;
